import { Text } from "react-native";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import MedicationModalTemplate from "../organisms/MedicationModalTemplate";
import { View } from "ui/atoms/view";
import { FormControlledInputTextArea } from "ui/molecules/form/FormControlledInputTextArea";
import { useMedicationModal } from "../contexts/MedicationModalContext";
import { MedicationEndedWarning } from "../organisms/MedicationEndedWarning";

interface Props {
  onClose: () => void;
  selfAdminister?: boolean;
  medicationId: number;
}

function Content() {
  const { control, isSubmitting, medication } = useMedicationModal();

  return (
    <View className="gap-2">
      <Text className="text-typography-900 capitalize font-semibold text-sm mb-4">
        Administer
      </Text>
      <FormControlledInput
        id="dosage"
        name="dosage"
        label="Dosage and unit of measure"
        placeholder="Enter dosage"
        control={control}
        isRequired
        isDisabled={isSubmitting}
      />
      <FormControlledInputTextArea
        id="other_information"
        name="other_information"
        label="Notes"
        placeholder="Enter note"
        control={control}
        isDisabled={isSubmitting}
      />

      <MedicationEndedWarning medication={medication} className="mt-5" />
    </View>
  );
}

export default function AdministerMedicationFormTemplate({
  onClose,
  selfAdminister,
  medicationId,
}: Props) {
  return (
    <MedicationModalTemplate
      onClose={onClose}
      selfAdminister={selfAdminister}
      medicationId={medicationId}
    >
      <Content />
    </MedicationModalTemplate>
  );
}
